import React from "react";
import ReactDOM from "react-dom/client";
import "@mantine/core/styles.css";
import "@mantine/dropzone/styles.css";
import "@mantine/notifications/styles.css";
import App from "./App.jsx";
import mixpanel from "mixpanel-browser";
import * as Sentry from "@sentry/react";

const devMode = import.meta.env.VITE_DEV;
const trackingKey = import.meta.env.VITE_TRACKING_KEY;

if (devMode === "true") {
  mixpanel.init(trackingKey, {
    debug: true,
    track_pageview: true,
    ignore_dnt: false,
    persistence: "localStorage",
  });
  console.warn("TRACKING IN DEV MODE!");
} else {
  mixpanel.init(trackingKey, {
    debug: false,
    track_pageview: true,
    ignore_dnt: true,
    persistence: "localStorage",
  });
}

/// TBD: Also we decided to ignore errors with statusCode in between
/// 400 to 426 using the beforeSend callback of sentry.
if (devMode !== "true") {
  Sentry.init({
    dsn: "https://24cff35c84f64be68497d98c638588e6@o4508133136662528.ingest.us.sentry.io/4508133138300928",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.httpClientIntegration() // This integration is required for capturing HTTP requests (Fetch failed)
    ],
    // This option is required for capturing headers and cookies.
    sendDefaultPii: true,
    // TBD: When it's clear that the errors are not CORS-related, enable this:
    // ignoreErrors: [
    //   'TypeError: Failed to fetch',
    //   'TypeError: NetworkError when attempting to fetch resource.'
    // ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/app\.photovortex\.com\/api/,
    ],
    // Session Replay
    replaysSessionSampleRate: 0.05, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
